import React from 'react';
import { useStore } from '../../../store';
import { PreLoad } from '../steps/PreLoad';
import { MoveMoneySteps } from '../consts';
import { MoveMoneyIntroStep } from '../steps/MoveMoneyIntroStep';
import { VendorUpdate } from '../steps/VendorUpdate';
import { VendorPicker } from '../steps/VendorPicker';
import { MoveMoneyAmountStep } from '../steps/MoveMoneyAmountStep';
import { Review } from '../steps/Review';
import { MoveMoneyMfaStep } from '../steps/MoveMoneyMfaStep';
import { Success } from '../steps/Success';
import { PurposeOfTransfer } from '../steps/PurposeOfTransfer';
import { InternationalWireEdd } from '../steps/InternationalWireEdd';

export const StepSwitcher = () => {
  const moveMoneyData = useStore(state => state.moveMoneyData);
  function renderStep() {
    switch (moveMoneyData.activeStepId) {
      case MoveMoneySteps.PRE_LOAD:
        return <PreLoad />;

      case MoveMoneySteps.INTRO:
        return <MoveMoneyIntroStep />;

      case MoveMoneySteps.VENDOR_UPDATE:
        return <VendorUpdate />;

      case MoveMoneySteps.VENDOR_PICKER:
        return <VendorPicker />;

      case MoveMoneySteps.AMOUNT:
        return <MoveMoneyAmountStep />;

      case MoveMoneySteps.PURPOSE_OF_TRANSFER:
        return <PurposeOfTransfer />;

      case MoveMoneySteps.INTERNATIONAL_WIRE_EDD:
        return <InternationalWireEdd />;

      case MoveMoneySteps.REVIEW:
        return <Review />;

      case MoveMoneySteps.MFA:
        return <MoveMoneyMfaStep />;

      case MoveMoneySteps.SUCCESS:
        return <Success />;

      default:
        return <MoveMoneyIntroStep />;
    }
  }
  return <div className='w-full h-full'>{renderStep()}</div>;
};
